import { render } from "./GoodsTableReturned.vue?vue&type=template&id=47509925&scoped=true"
import script from "./GoodsTableReturned.vue?vue&type=script&lang=js"
export * from "./GoodsTableReturned.vue?vue&type=script&lang=js"

import "./GoodsTableReturned.vue?vue&type=style&index=0&id=47509925&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47509925"]])

export default __exports__